import { AddressInterface } from 'common/address.interface';
import {
  ChargeRequestHistory,
  ChargeRequestOrderInterface,
  CompanyPaymentRequestsInterface,
  PaymentRequestInterface,
} from '../orders/types';
import { TaxInterface } from '../tax/types';

/*
 * Action Types
 */
export enum CompaniesTypes {
  LIST_COMPANIES_REQUEST = '@companies/LIST_COMPANIES_REQUEST',
  LIST_COMPANIES_SUCCESS = '@companies/LIST_COMPANIES_SUCCESS',
  LIST_COMPANIES_FAILURE = '@companies/LIST_COMPANIES_FAILURE',

  GET_COMPANY_REQUEST = '@companies/GET_COMPANY_REQUEST',
  GET_COMPANY_SUCCESS = '@companies/GET_COMPANY_SUCCESS',
  GET_COMPANY_FAILURE = '@companies/GET_COMPANY_FAILURE',

  AUTH_COMPANIES_REQUEST = '@companies/AUTH_COMPANIES_REQUEST',
  AUTH_COMPANIES_SUCCESS = '@companies/AUTH_COMPANIES_SUCCESS',
  AUTH_COMPANIES_FAILURE = '@companies/AUTH_COMPANIES_FAILURE',

  REPORT_COMPANY_REQUEST = '@companies/REPORT_COMPANY_REQUEST',
  REPORT_COMPANY_SUCCESS = '@companies/REPORT_COMPANY_SUCCESS',
  REPORT_COMPANY_FAILURE = '@companies/REPORT_COMPANY_FAILURE',

  FORGOT_PASSWORD_REQUEST = '@companies/FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS = '@companies/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE = '@companies/FORGOT_PASSWORD_FAILURE',

  FILTER_COMPANIES_REQUEST = '@companies/FILTER_COMPANIES_REQUEST',
  FILTER_COMPANIES_SUCCESS = '@companies/FILTER_COMPANIES_SUCCESS',
  FILTER_COMPANIES_FAILURE = '@companies/FILTER_COMPANIES_FAILURE',

  CREATE_COMPANY_REQUEST = '@companies/CREATE_COMPANY_REQUEST',
  CREATE_COMPANY_SUCCESS = '@companies/CREATE_COMPANY_SUCCESS',
  CREATE_COMPANY_FAILURE = '@companies/CREATE_COMPANY_FAILURE',

  UPDATE_COMPANY_REQUEST = '@companies/UPDATE_COMPANY_REQUEST',
  UPDATE_COMPANY_SUCCESS = '@companies/UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_FAILURE = '@companies/UPDATE_COMPANY_FAILURE',

  UPDATE_REPORT_LIMIT_REQUEST = '@companies/UPDATE_REPORT_LIMIT_REQUEST',
  UPDATE_REPORT_LIMIT_SUCCESS = '@companies/UPDATE_REPORT_LIMIT_SUCCESS',
  UPDATE_REPORT_LIMIT_FAILURE = '@companies/UPDATE_REPORT_LIMIT_FAILURE',

  DELETE_COMPANY_REQUEST = '@companies/DELETE_COMPANY_REQUEST',
  DELETE_COMPANY_SUCCESS = '@companies/DELETE_COMPANY_SUCCESS',
  DELETE_COMPANY_FAILURE = '@companies/DELETE_COMPANY_FAILURE',

  SET_SELECTED_TYPE = '@companies/SET_SELECTED_TYPE',
  SET_SELECTED_STATUS = '@companies/SET_SELECTED_STATUS',
  SET_SELECTED_PAYMENT_TYPE = '@companies/SET_SELECTED_PAYMENT_TYPE',

  FORGOT_COMPANIES_REQUEST = '@companies/FORGOT_COMPANIES_REQUEST',
  FORGOT_COMPANIES_SUCCESS = '@companies/FORGOT_COMPANIES_SUCCESS',
  FORGOT_COMPANIES_FAILURE = '@companies/FORGOT_COMPANIES_FAILURE',

  LIST_MANAGEMENT_PAYMENT_REQUEST = '@companies/LIST_MANAGEMENT_PAYMENT_REQUEST',
  LIST_MANAGEMENT_PAYMENT_SUCCESS = '@companies/LIST_MANAGEMENT_PAYMENT_SUCCESS',
  LIST_MANAGEMENT_PAYMENT_FAILURE = '@companies/LIST_MANAGEMENT_PAYMENT_FAILURE',

  CREATE_MANAGEMENT_PAYMENT_REQUEST = '@companies/CREATE_MANAGEMENT_PAYMENT_REQUEST',
  CREATE_MANAGEMENT_PAYMENT_SUCCESS = '@companies/CREATE_MANAGEMENT_PAYMENT_SUCCESS',
  CREATE_MANAGEMENT_PAYMENT_FAILURE = '@companies/CREATE_MANAGEMENT_PAYMENT_FAILURE',

  UPDATE_MANAGEMENT_PAYMENT_REQUEST = '@companies/UPDATE_MANAGEMENT_PAYMENT_REQUEST',
  UPDATE_MANAGEMENT_PAYMENT_SUCCESS = '@companies/UPDATE_MANAGEMENT_PAYMENT_SUCCESS',
  UPDATE_MANAGEMENT_PAYMENT_FAILURE = '@companies/UPDATE_MANAGEMENT_PAYMENT_FAILURE',

  UPDATE_MANAGEMENT_PAYMENT_STATUS_REQUEST = '@companies/UPDATE_MANAGEMENT_PAYMENT_STATUS_REQUEST',
  UPDATE_MANAGEMENT_PAYMENT_STATUS_SUCCESS = '@companies/UPDATE_MANAGEMENT_PAYMENT_STATUS_SUCCESS',
  UPDATE_MANAGEMENT_PAYMENT_STATUS_FAILURE = '@companies/UPDATE_MANAGEMENT_PAYMENT_STATUS_FAILURE',

  LIST_BOARDING_HISTORY_REQUEST = '@companies/LIST_BOARDING_HISTORY_REQUEST',
  LIST_BOARDING_HISTORY_SUCCESS = '@companies/LIST_BOARDING_HISTORY_SUCCESS',
  LIST_BOARDING_HISTORY_FAILURE = '@companies/LIST_BOARDING_HISTORY_FAILURE',

  DELETE_MANAGEMENT_PAYMENT_REQUEST = '@companies/DELETE_MANAGEMENT_PAYMENT_REQUEST',
  DELETE_MANAGEMENT_PAYMENT_SUCCESS = '@companies/DELETE_MANAGEMENT_PAYMENT_SUCCESS',
  DELETE_MANAGEMENT_PAYMENT_FAILURE = '@companies/DELETE_MANAGEMENT_PAYMENT_FAILURE',

  LIST_VEHICLE_REQUEST = '@companies/LIST_VEHICLE_REQUEST',
  LIST_VEHICLE_SUCCESS = '@companies/LIST_VEHICLE_SUCCESS',
  LIST_VEHICLE_FAILURE = '@companies/LIST_VEHICLE_FAILURE',

  CREATE_VEHICLE_REQUEST = '@companies/CREATE_VEHICLE_REQUEST',
  CREATE_VEHICLE_SUCCESS = '@companies/CREATE_VEHICLE_SUCCESS',
  CREATE_VEHICLE_FAILURE = '@companies/CREATE_VEHICLE_FAILURE',

  UPDATE_VEHICLE_REQUEST = '@companies/UPDATE_VEHICLE_REQUEST',
  UPDATE_VEHICLE_SUCCESS = '@companies/UPDATE_VEHICLE_SUCCESS',
  UPDATE_VEHICLE_FAILURE = '@companies/UPDATE_VEHICLE_FAILURE',

  DELETE_VEHICLE_REQUEST = '@companies/DELETE_VEHICLE_REQUEST',
  DELETE_VEHICLE_SUCCESS = '@companies/DELETE_VEHICLE_SUCCESS',
  DELETE_VEHICLE_FAILURE = '@companies/DELETE_VEHICLE_FAILURE',

  COMPANY_BOLETO_CONFIG_CREATE_MANY_REQUEST = '@companies/COMPANY_BOLETO_CONFIG_CREATE_MANY_REQUEST',
  COMPANY_BOLETO_CONFIG_CREATE_MANY_SUCCESS = '@companies/COMPANY_BOLETO_CONFIG_CREATE_MANY_SUCCESS',
  COMPANY_BOLETO_CONFIG_CREATE_MANY_FAILURE = '@companies/COMPANY_BOLETO_CONFIG_CREATE_MANY_FAILURE',

  COMPANY_BOLETO_CONFIG_LIST_REQUEST = '@companies/COMPANY_BOLETO_CONFIG_LIST_REQUEST',
  COMPANY_BOLETO_CONFIG_LIST_SUCCESS = '@companies/COMPANY_BOLETO_CONFIG_LIST_SUCCESS',
  COMPANY_BOLETO_CONFIG_LIST_FAILURE = '@companies/COMPANY_BOLETO_CONFIG_LIST_FAILURE',

  COMPANY_BOLETO_CONFIG_UPDATE_MANY_REQUEST = '@companies/COMPANY_BOLETO_CONFIG_UPDATE_MANY_REQUEST',
  COMPANY_BOLETO_CONFIG_UPDATE_MANY_SUCCESS = '@companies/COMPANY_BOLETO_CONFIG_UPDATE_MANY_SUCCESS',
  COMPANY_BOLETO_CONFIG_UPDATE_MANY_FAILURE = '@companies/COMPANY_BOLETO_CONFIG_UPDATE_MANY_FAILURE',

  COMPANY_BOLETO_CONFIG_DELETE_REQUEST = '@companies/COMPANY_BOLETO_CONFIG_DELETE_REQUEST',
  COMPANY_BOLETO_CONFIG_DELETE_SUCCESS = '@companies/COMPANY_BOLETO_CONFIG_DELETE_SUCCESS',
  COMPANY_BOLETO_CONFIG_DELETE_FAILURE = '@companies/COMPANY_BOLETO_CONFIG_DELETE_FAILURE',
}

/*
 * Data types
 */

export interface CompanyTaxInterface {
  id: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  companyId: string;
  addressId?: string;
  taxId?: string;
}
export interface VehicleInterface {
  id: string;
  companyId: string;
  license: string;
  brand: string;
  model: string;
  type: string;
}

export interface SellingPointTransactionsInterface {
  id: string;
  supervisorId: string;
  usedDate: string;
  createdAt: string;
  transportOperatorId: string;
  amount: number;
  vehicleId: string;
  PaymentRequest: {
    id: string;
    value: number;
  };
}
export interface CompanyInterface {
  id: string;
  name: string;
  cnpj: string;
  phone: string;
  email: string;
  Addresses: AddressInterface[];
  Taxes?: TaxInterface[];
  createdAt: string;
  updatedAt: string;
  recaptcha?: any;
  status: string;
  invoiceDisabled: boolean;
  Vehicles?: VehicleInterface[];
  SellingPointTransactions?: SellingPointTransactionsInterface[];
  CompanyPaymentRequests?: CompanyPaymentRequestsInterface[];
  CompanyBoletoConfig?: CompanyBoletoConfigListRequestInterface;
}

type Type = 'COMPANY' | 'USER';

export interface CompanyReportInterface {
  id: string;
  name: string;
  cnpj: string;
  document: string;
  userId: string;
  type: Type;
  status: number;
  value: number;
  count: number;
  totalValue?: number;
  nsu: number | null;
  usedDate: string;
  createdAt: string;
  updatedAt: string;
  paymentMethod?: string;
  PaymentRequest: PaymentRequestInterface;
  ChargeRequestHistories: ChargeRequestHistory[];
  ChargeRequestOrders: ChargeRequestOrderInterface[];
  Taxes?: TaxInterface[];
}

export interface SelectedReportTypesInterface {
  KEY: string;
  VALUE: string;
}

export interface CompanyAuthInterface {
  kind: string;
  localId: string;
  email: string;
  displayName: string;
  idToken: string;
  registered: boolean;
  refreshToken: string;
  expiresIn: string;
}
export interface BoletoConfigInterface {
  id: string;
  expiration: number;
  description: string;
  min: number;
  authToken: string;
  key: string;
  username: string;
  password: string;
  certificate: string;
  certificatePassword: string;
  agency: string;
  place: string;
  cedente: string;
  document: string;
  name: string;
  account: string;
  number: string;
  convenio: string;
  createdAt: string;
  updatedAt: string;
  paymentConfigId: string;
}

export interface PixsConfigInterface {
  id: string;
  expiration: number;
  description: string;
  operator: string;
  name: string;
  min: number;
  key: string;
  username: string;
  password: string;
  certificate: string;
  certificatePassword: string;
  createdAt: string;
  updatedAt: string;
  paymentConfigId: string;
}

export interface BoardingHistoryInterface {
  date: string;
  license: string;
  brand: string;
  model: string;
  type: string;
  employee: string;
  value: number;
}

export interface CardConfigInterface {
  id: string;
  username: string;
  password: string;
  description: string;
  min: number;
  max: number;
  antifraudUsername: string;
  antrifraudPassword: string;
  antifraudType: string;
}

export interface EmvConfigInterface {
  id: string;
  username: string;
  password: string;
}

export interface PaymentConfigInterface {
  transportOperatorId: string;
  id: string;
  type: 'PIX' | 'BOLETO' | 'CREDIT_CARD' | 'EMV';
  channels: string[];
  bank: 'SICREDI' | 'BB' | 'SANTANDER';
  status: 0;
  createdAt: '';
  updatedAt: '';
  PaymentPixConfig: PixsConfigInterface | null;
  PaymentCardConfig: CardConfigInterface | null;
  PaymentEmvConfig: EmvConfigInterface | null;
  PaymentBoletoConfig: BoletoConfigInterface | null;
}

export interface InvoicesInterface {
  date: string;
  license: string;
  brand: string;
  model: string;
  type: string;
  supervisorName: string;
  amount: string;
  createdAt: string;
}

export interface CompanyBoletoConfigListRequestInterface {
  id: string;
  expiration: number;
  description: null;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  companyId: string;
}

/*
 * State type
 */
export interface CompaniesState {
  readonly companiesList: CompanyInterface[];
  readonly companiesListFull: CompanyInterface[];
  readonly companyCreated: CompanyInterface;
  readonly companyData: CompanyInterface;
  readonly companyAuth: CompanyAuthInterface | null;
  readonly companyReportList: CompanyReportInterface[];
  readonly selectedType: SelectedReportTypesInterface[];
  readonly selectedStatus: string | number;
  readonly selectedPaymentType: SelectedReportTypesInterface[];
  readonly paymentMethodList: PaymentConfigInterface[];
  readonly paymentMethodData: PaymentConfigInterface;
  readonly boardingHistoryList: BoardingHistoryInterface[];
  readonly companyBoletoConfigList: CompanyBoletoConfigListRequestInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
